module.exports = __webpack_public_path__ + "static/media/shaken.4bceff85.png";